import {addEvent} from '../add-event'

export function selectToTimePeriodEvent(currentTimePeriod: string, newTimePeriod: string): boolean {
    return addEvent('reportsPageSelectToTimePeriod', {currentTimePeriod, newTimePeriod})
}
